import { useTranslation } from 'react-i18next';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

export default function OfflineBanner() {
  const { t } = useTranslation('common');
  const { isOnline, isSyncing, pendingCount } = useOnlineStatus();

  if (isOnline && !isSyncing && pendingCount === 0) {
    return null;
  }

  return (
    <div className={`text-center text-sm py-2 px-4 ${
      !isOnline
        ? 'bg-gray-700 text-white'
        : 'bg-yellow-100 text-yellow-800'
    }`}>
      {!isOnline && (
        <span>{t('offline.banner.offline')}</span>
      )}
      {isOnline && isSyncing && (
        <span>{t('offline.banner.syncing')}</span>
      )}
      {isOnline && !isSyncing && pendingCount > 0 && (
        <span>{t('offline.banner.pendingChanges', { count: pendingCount })}</span>
      )}
    </div>
  );
}
